import React from 'react';
import ClarityAnalytics from './clarity-analytics';
import PageAnalytics from './page-analytics';

const Analytics = () => (
  <>
    <PageAnalytics />
    <ClarityAnalytics />
  </>
);

export default Analytics;
